export const RETURN_TO = 'return_to'

export const PASSWORD = 'password'
export const EMAIL_ADDRESS = 'email-address'
export const EMAIL = 'email address'
export const EMAIL_PARAM = 'email'
export const PARAMS = [RETURN_TO, EMAIL_PARAM]
export const REQUIRED_FIELDS = [EMAIL_ADDRESS, PASSWORD]
export const DEFAULT_LOCKED_OUT_MSG = 'The user is locked out'

export const SUCCESSFUL_LOGIN = 'successfulLogin'

export const REQUIRED_RULE = (formItem: typeof PASSWORD | typeof EMAIL) => {
    const defaultRules: { [key: string]: any }[] = [
        {
            required: true,
            message: `Please input your ${formItem}`,
        },
    ]

    if (formItem === EMAIL) {
        defaultRules.push({
            type: 'email',
            message: 'Please enter a valid email address',
        })
    }

    return defaultRules
}
